import { render, staticRenderFns } from "./websiteconfig.vue?vue&type=template&id=d829972c"
import script from "./websiteconfig.vue?vue&type=script&lang=js"
export * from "./websiteconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports